module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "share",
    class: {
      selected: _vm.selected
    },
    on: {
      "click": function($event) {
        _vm.updateSelected()
      }
    }
  }, [_vm._c('div', {
    staticClass: "icon"
  }, [(!_vm.selected) ? _vm._c('i', {
    staticClass: "far fa-square"
  }) : _vm._e(), _vm._v(" "), (_vm.selected) ? _vm._c('i', {
    staticClass: "fas fa-check-square"
  }) : _vm._e()]), _vm._v(" "), _vm._c('span', [_vm._c('strong', [_vm._v(_vm._s(_vm.share.sender_email))]), _vm._v(" has shared their study notes '"), _vm._c('strong', [_vm._v(_vm._s(_vm.share.chapter_name))]), _vm._v("' with you.")]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-992ff5a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-sharer/ReceiveChapterRow.vue
// module id = 698
// module chunks = 1